import React from 'react';

// === components ===
import { Lobby, Layout } from '../../components';

const GamePage: React.FC = () => {
  return (
    <Layout>
      <Lobby />
    </Layout>
  );
};

export default GamePage;
